import { NavBrandTitle } from '@cottage/design-system/internal-tooling/ui'

interface BootSplashProps {
  showIdleHint?: boolean
}

export default function BootSplash({ showIdleHint = false }: BootSplashProps) {
  return (
    <div className="flex min-h-full items-center justify-center bg-gray-50 px-4 py-12">
      <div
        className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div className="text-center">
          <NavBrandTitle
            accent="Book"
            rest="Keeper"
            className="inline-block text-2xl font-semibold"
          />
          <div
            className="mx-auto mt-6 h-6 w-6 animate-spin rounded-full border-2 border-gray-200 border-t-[var(--color-product,#456650)]"
            aria-hidden="true"
          />
          <p
            className={`mt-4 text-sm text-gray-500 transition-opacity duration-300 ${
              showIdleHint ? 'opacity-100' : 'opacity-0'
            }`}
            aria-hidden={!showIdleHint}
          >
            Starting up, please wait...
          </p>
        </div>
      </div>
    </div>
  )
}
